import { useRightDrawerRolodexEntries } from 'features/rightDrawer/useRightDrawerRolodexEntries'
import { useRightDrawer } from 'features/rightDrawer/utils/RightDrawerProvider'
import React from 'react'

import { UploadFile, type UploadFileProps } from './UploadFile'

type UploadFileDrawerProps = Omit<UploadFileProps, 'onClose' | 'organization'>

export const UploadFileDrawer: React.FC<UploadFileDrawerProps> = (props) => {
  const { organization } = useRightDrawerRolodexEntries({
    siteID: props.siteID,
  })
  const { closeDrawer } = useRightDrawer()

  return (
    <UploadFile
      organization={organization}
      onClose={closeDrawer}
      siteID={props.siteID}
      unitID={props.unitID}
    />
  )
}
